@if (forms) {
  <div class="keys-container astral-stack-l">
    @for (form of $any(forms.controls); track form; let i = $index) {
      <section class="keys-container__key astral-section-surface astral-section-surface--compact astral-stack-m">
        <h5>{{ 'KEYTYPE.KEY_X_OF_Y' | translate: { x: i + 1, y: forms.length } }}</h5>
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['key']"></astral-input>
          <astral-input [control]="form.controls['caption']"></astral-input>
          <astral-select [control]="form.controls['keyTypeId']" [itemsSource]="keyTypes"></astral-select>
          <astral-input [control]="form.controls['systemNumber']"></astral-input>
          <astral-input [control]="form.controls['supplier']"></astral-input>
          <astral-input [control]="form.controls['marking']"></astral-input>
          <astral-input [integerOnly]="true" [control]="form.controls['quantityLentOut']"></astral-input>
          <astral-input [integerOnly]="true" [control]="form.controls['quantityInStorage']"></astral-input>
          <astral-input [integerOnly]="true" [control]="form.controls['quantity']"></astral-input>
          <div class="astral-form-adjacent-action">
            <astral-button variant="secondary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="delete(form)"></astral-button>
          </div>
        </astral-layout-group>
      </section>
    }
    <astral-button class="keys-container__add-key" variant="primary" size="small" type="button" icon="plus" labelKey="KEYTYPE.ADD_KEY" (click)="addKey()"></astral-button>
    @if (keyTypes.length === 0) {
      <app-information-block [text]="'KEYTYPE.NO_KEYTYPES' | translate"></app-information-block>
    }
  </div>
}
